import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageMeta, getPageUrl, BASE_URL, SITE_NAME } from '../../config/seo';

/**
 * SEO komponenta pro dynamické nastavení meta tagů
 * Používá document API pro nastavení <head> tagů
 */
export const Seo = ({ 
  title: customTitle, 
  description: customDescription,
  image,
  type = 'website',
  robots
}) => {
  const location = useLocation();
  const meta = getPageMeta(location.pathname);
  
  const title = customTitle || meta.title;
  const description = customDescription || meta.description;
  const url = getPageUrl(location.pathname);
  
  // Default OG image podle typu stránky
  const getDefaultOgImage = () => {
    if (image) return image;
    if (type === 'article' || location.pathname.startsWith('/blog')) {
      return `${BASE_URL}/og-blog.jpg`;
    }
    return `${BASE_URL}/og-default.jpg`;
  };
  
  const ogImage = getDefaultOgImage();

  useEffect(() => {
    // Basic Meta Tags
    document.title = title;
    
    // Description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    // Robots (volitelně)
    if (robots) {
      let metaRobots = document.querySelector('meta[name="robots"]');
      if (!metaRobots) {
        metaRobots = document.createElement('meta');
        metaRobots.setAttribute('name', 'robots');
        document.head.appendChild(metaRobots);
      }
      metaRobots.setAttribute('content', robots);
    }
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
    
    // Open Graph tags
    const ogTags = {
      'og:type': type,
      'og:url': url,
      'og:title': title,
      'og:description': description,
      'og:image': ogImage,
      'og:image:width': '1200',
      'og:image:height': '630',
      'og:site_name': SITE_NAME,
      'og:locale': 'cs_CZ',
    };
    
    Object.entries(ogTags).forEach(([property, content]) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });
    
    // Twitter Card tags
    const twitterTags = {
      'twitter:card': 'summary_large_image',
      'twitter:title': title,
      'twitter:description': description,
      'twitter:image': ogImage,
    };
    
    Object.entries(twitterTags).forEach(([name, content]) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });
  }, [title, description, url, ogImage, type, robots]);

  // Tato komponenta nevykresluje žádný JSX, pouze upravuje <head>
  return null;
};

